(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[2051],{

/***/ 560:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/services/tech-stack-audit",
      function () {
        return __webpack_require__(2059);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 2059:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": function() { return /* binding */ techStackAudit; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(9815);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(9008);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_head__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(1664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(5152);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(next_dynamic__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _utils_blogUtils__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(1180);
/* harmony import */ var _blogs_json__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(2684);
/* harmony import */ var _components_services_Service2__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(3230);
/* harmony import */ var _components_services_ServiceFAQ__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(2616);
/* harmony import */ var _components_services_ServiceEngagementLinks__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(5733);
/* harmony import */ var _components_ai_agent_demo_CustomerSection__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(4837);
/* harmony import */ var next_future_image__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(1608);
/* harmony import */ var next_future_image__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(next_future_image__WEBPACK_IMPORTED_MODULE_9__);








var Capabilities2 = next_dynamic__WEBPACK_IMPORTED_MODULE_3___default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(5791), __webpack_require__.e(8388), __webpack_require__.e(5290), __webpack_require__.e(7517), __webpack_require__.e(7113)]).then(__webpack_require__.bind(__webpack_require__, 7517));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(7517)
            ];
        }
    },
    ssr: false
});




var Footer = next_dynamic__WEBPACK_IMPORTED_MODULE_3___default()(function() {
    return __webpack_require__.e(/* import() */ 2941).then(__webpack_require__.bind(__webpack_require__, 3193));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(3193)
            ];
        }
    },
    ssr: false
});
techStackAudit.title = "Tech Stack Audit Services | Software, Cloud & Security | ITMTB";
techStackAudit.desc = "ITMTB provides tech stack audit services across software architecture, cloud infrastructure, databases, integrations, security posture, performance risks, technical debt, and operations readiness.";
techStackAudit.header_img = "https://www.itmtb.com/services/capability/automate.webp";
techStackAudit.keywords = "tech stack audit services India, technology stack audit, software architecture review, cloud infrastructure audit, technical debt assessment, legacy system audit, IT stack review, technical due diligence India";
var faqItems = [
    {
        q: "What are tech stack audit services?",
        a: "Tech stack audit services assess the software, cloud infrastructure, databases, integrations, security controls, deployment process, technical debt, and operations model behind a live technology system. The goal is to identify risks, bottlenecks, cost issues, and modernisation priorities before making decisions that are difficult to reverse."
    },
    {
        q: "When should a company conduct a tech stack audit?",
        a: "A company should conduct a tech stack audit before a rebuild, migration, vendor transition, funding round, acquisition, scale-up phase, cloud optimisation effort, AI adoption project, or major technology investment. It is most useful before decisions where the real condition of the existing system directly affects the outcome."
    },
    {
        q: "What does a tech stack audit include?",
        a: "A tech stack audit typically includes application architecture review, cloud infrastructure assessment, database and data-flow review, integration mapping, performance review, security and access-control observations, DevOps process review, technical debt assessment, and a prioritised roadmap. The exact scope is agreed during an initial discovery conversation."
    },
    {
        q: "Is a tech stack audit the same as technical due diligence?",
        a: "They overlap, but are not always the same. Technical due diligence is usually tied to investment, acquisition, or strategic evaluation. A tech stack audit can be broader and more operational — helping a company decide what to fix, modernise, rebuild, migrate, or operate better. ITMTB delivers both depending on the decision context."
    },
    {
        q: "Can ITMTB audit software built by another vendor?",
        a: "Yes. ITMTB can audit systems built by internal teams, external agencies, outsourced vendors, or mixed teams. A common use case is helping leadership understand the condition of a system before continuing with the same vendor, changing vendors, or bringing technology ownership in-house."
    },
    {
        q: "Do you review cloud infrastructure as part of the audit?",
        a: "Yes. The audit can include AWS, Azure, GCP, hosting setup, compute, storage, networking, backups, monitoring, deployment environments, access controls, cost risks, and reliability concerns."
    },
    {
        q: "Do you review security as part of the audit?",
        a: "Yes. The audit includes basic security hygiene, user access, admin privileges, secrets handling, cloud keys, service accounts, audit trails, and operational security risks. A deeper cybersecurity assessment can be scoped separately if required."
    },
    {
        q: "How long does a tech stack audit take?",
        a: "A focused tech stack audit sprint can usually be completed in 2 weeks, depending on system complexity, access availability, documentation quality, and the depth of review required. A deeper audit with implementation planning takes 2–4 weeks."
    },
    {
        q: "What do we receive at the end of the audit?",
        a: "You receive a written report with current-state observations, major risks, technical debt areas, performance and scalability findings, security and access-control observations, operational risks, and a prioritised 30/60/90-day roadmap. The goal is to help leadership decide what to do next — not to produce a long theoretical document."
    },
    {
        q: "Can ITMTB implement the recommendations after the audit?",
        a: "Yes. ITMTB can support implementation through application modernisation, cloud optimisation, security hardening, performance improvement, DevOps setup, QA improvement, AI/data-readiness work, or managed services. The audit roadmap becomes the brief for the implementation engagement."
    },
    {
        q: "Is this useful for startups?",
        a: "Yes. A tech stack audit is useful for startups preparing to scale, raise funding, transition from an agency-built system, reduce technical debt, or understand whether their current architecture can support the next phase."
    },
    {
        q: "Is this useful for enterprises?",
        a: "Yes. Enterprises can use a tech stack audit before modernisation, cloud migration, vendor consolidation, compliance improvement, operational restructuring, or AI automation initiatives."
    }, 
];
techStackAudit.faq = faqItems;
var jsonLd = {
    "@context": "https://schema.org",
    "@graph": [
        {
            "@type": "Service",
            "name": "Tech Stack Audit Services",
            "provider": {
                "@type": "Organization",
                "name": "ITMTB",
                "url": "https://www.itmtb.com",
                "logo": "https://www.itmtb.com/logo.webp",
                "sameAs": [
                    "https://www.linkedin.com/company/itmtb-technologies/",
                    "https://x.com/ITMTBTech", 
                ]
            },
            "areaServed": {
                "@type": "Country",
                "name": "India"
            },
            "serviceType": "Technology Stack Audit",
            "description": "ITMTB provides tech stack audit services across software architecture, cloud infrastructure, databases, integrations, security posture, performance risks, technical debt, and operations readiness.",
            "offers": {
                "@type": "Offer",
                "priceSpecification": {
                    "@type": "PriceSpecification",
                    "description": "Fixed-price 2-week audit sprint, then custom proposal based on scope"
                }
            }
        }, 
    ]
};
var auditAreas = [
    {
        img: null,
        key: "Application Architecture",
        title: "How your application is built — and where it will break under pressure.",
        text: "We review the structure of your application, backend services, frontend layers, APIs, modules, dependencies, code organisation, and system boundaries.\n\nCommon findings include undocumented service boundaries, missing abstraction layers, high coupling between components, framework lock-in, and architectural decisions that made sense at small scale but constrain growth."
    },
    {
        img: null,
        key: "Cloud Infrastructure",
        title: "Whether your cloud setup can support what you are about to ask of it.",
        text: "We assess your hosting environment, cloud architecture, compute, storage, networking, scaling approach, backups, deployment environments, and reliability setup.\n\nCommon findings include over-provisioned compute alongside under-provisioned databases, missing backup verification, environments that are not properly isolated, and cost structures that scale faster than the product."
    },
    {
        img: null,
        key: "Database and Data Flows",
        title: "Data problems hide longer than any other class of technical risk.",
        text: "We review database design, data movement, schema complexity, query pressure, reporting dependencies, data duplication, and operational risks in critical data flows.\n\nCommon findings include missing indexes, unbounded queries that scale linearly with data volume, reporting loads competing with transactional loads, and data duplication that has quietly diverged."
    },
    {
        img: null,
        key: "APIs and Integrations",
        title: "Your integrations are only as reliable as their least-tested failure path.",
        text: "We assess internal APIs, third-party integrations, payment systems, SaaS dependencies, authentication flows, and integration failure points.\n\nCommon findings include integrations with no retry logic, payment flows without idempotency keys, third-party dependencies with no fallback, and API versioning that has been ignored until it becomes a breaking-change problem."
    },
    {
        img: null,
        key: "Security and Access Controls",
        title: "Access control gaps create incidents months or years after the code is written.",
        text: "We review user access, admin privileges, cloud keys, service accounts, secrets handling, basic security hygiene, and auditability gaps.\n\nCommon findings include service accounts with broader permissions than required, secrets in environment files committed to version control, and admin access that has never been audited since the system was handed over."
    },
    {
        img: null,
        key: "Performance and Scalability",
        title: "Bottlenecks that are invisible at current load become crises at 3x.",
        text: "We identify bottlenecks affecting response time, throughput, database load, infrastructure usage, frontend performance, and user experience.\n\nCommon findings include synchronous operations that should be queued, N+1 query patterns, caching layers that don't exist where they should, and load assumptions that were never pressure-tested."
    },
    {
        img: null,
        key: "DevOps and Deployment Process",
        title: "A release process that makes people nervous is a release process that is broken.",
        text: "We review CI/CD, deployment discipline, rollback readiness, environment separation, release controls, and production-change risk.\n\nCommon findings include no staging environment, no automated tests in the deployment pipeline, rollback procedures that have never been tested, and deployment coordination that depends on a single developer being available."
    },
    {
        img: null,
        key: "Monitoring and Incident Readiness",
        title: "Most production incidents are discovered by users, not by monitoring.",
        text: "We assess logging, alerts, uptime monitoring, error tracking, escalation process, incident visibility, and operational reporting.\n\nCommon findings include alerts that trigger on everything (and are therefore ignored), no structured logging that can be queried after an incident, and uptime monitoring that watches the homepage but not the payment or data processing flows."
    },
    {
        img: null,
        key: "Technical Debt",
        title: "Technical debt rarely appears on the balance sheet until it causes an incident.",
        text: "We identify outdated frameworks, fragile modules, undocumented logic, weak test coverage, dependency risks, maintainability issues, and areas where development speed is being slowed down.\n\nCommon findings include end-of-life dependencies, business-critical logic that only one developer understands, test coverage that exists in name only, and framework versions that stopped receiving security patches."
    },
    {
        img: null,
        key: "Operations Ownership",
        title: "A system without a clear owner is one incident away from a crisis.",
        text: "We assess whether your current operating model can support the system after launch — including support ownership, escalation paths, reporting cadence, release coordination, and vendor dependency.\n\nCommon findings include production support implicitly owned by the build team, escalation paths that exist in someone's head but nowhere else, and single-vendor or single-developer dependencies with no contingency."
    }, 
];
var engagementPhases = [
    {
        phase: "01",
        title: "Discovery",
        items: [
            "Understand business context and current systems",
            "Identify known pain points and future plans",
            "Clarify the decisions the audit needs to support",
            "Agree audit scope, access requirements, and timeline", 
        ]
    },
    {
        phase: "02",
        title: "Stack Inventory",
        items: [
            "Review applications, cloud environments, and databases",
            "Map integrations, repositories, and deployment process",
            "Assess access controls and operational workflows",
            "Identify documentation gaps and undocumented dependencies", 
        ]
    },
    {
        phase: "03",
        title: "Technical Assessment",
        items: [
            "Architecture, maintainability, and code quality review",
            "Performance, scalability, and reliability analysis",
            "Security hygiene and access control assessment",
            "Cost risk and infrastructure efficiency review", 
        ]
    },
    {
        phase: "04",
        title: "Decision Framework",
        items: [
            "Classify each area: Keep / Fix / Modernise / Replace / Rebuild / Migrate / Automate / Monitor",
            "Prioritise by business risk and implementation effort",
            "Identify dependencies between improvement areas",
            "Map findings to the decisions the business needs to make", 
        ]
    },
    {
        phase: "05",
        title: "Roadmap Delivery",
        items: [
            "Written report with current-state observations and risk register",
            "30/60/90-day improvement roadmap with priority and effort",
            "Build-vs-extend-vs-replace recommendation",
            "Optional: implementation and managed-operations plan", 
        ]
    }, 
];
var engagementModels = [
    {
        label: "Audit Sprint",
        duration: "2 weeks \xb7 Fixed price",
        description: "A focused, fixed-scope audit for companies that need clarity quickly.",
        bestFor: [
            "Leadership decision-making",
            "Vendor transition evaluation",
            "Architecture review",
            "Technical due diligence",
            "Rebuild or migration decision", 
        ]
    },
    {
        label: "Audit + Roadmap",
        duration: "2–4 weeks",
        description: "A deeper assessment with implementation planning and sequenced improvement roadmap.",
        bestFor: [
            "Legacy modernisation planning",
            "Cloud migration preparation",
            "Scaling preparation",
            "Security and operations improvement",
            "AI and data readiness planning", 
        ]
    },
    {
        label: "Audit + Implementation",
        duration: "Scoped after audit",
        description: "An audit followed by execution — ITMTB helps fix, modernise, migrate, rebuild, or operate the stack.",
        bestFor: [
            "Application modernisation",
            "Cloud optimisation",
            "Security hardening",
            "DevOps and monitoring setup",
            "Managed services transition", 
        ]
    }, 
];
var featuredStory = {
    title: "Comprehensive Fintech Audit Unveiled: Mastering Complex Tech Stacks for Strategic Excellence",
    slug: "fintech-audit-tech-stacks-strategy",
    img: "/blogImages/hero/fintech.webp",
    industry_descriptor: "High-Growth Fintech Payments Company processing 1M+ transactions per 15 hours",
    outcome_metric: "Full technology audit delivered in one week — actionable recommendations tied to growth roadmap and KPIs"
};
function techStackAudit() {
    var allInsights = _blogs_json__WEBPACK_IMPORTED_MODULE_4__.filter(function(item) {
        var ref;
        return ![
            "case-study",
            "tech"
        ].includes(item === null || item === void 0 ? void 0 : (ref = item.meta) === null || ref === void 0 ? void 0 : ref.category);
    });
    var caseStudies = _blogs_json__WEBPACK_IMPORTED_MODULE_4__.filter(function(item) {
        var ref;
        return (item === null || item === void 0 ? void 0 : (ref = item.meta) === null || ref === void 0 ? void 0 : ref.slug) === "fintech-audit-tech-stacks-strategy";
    });
    var filteredInsights = allInsights.filter(function(i) {
        var ref, ref1, ref2, ref3;
        return (i === null || i === void 0 ? void 0 : (ref = i.meta) === null || ref === void 0 ? void 0 : (ref1 = ref.refer) === null || ref1 === void 0 ? void 0 : ref1.includes("Technology Consulting")) || (i === null || i === void 0 ? void 0 : (ref2 = i.meta) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.refer) === null || ref3 === void 0 ? void 0 : ref3.includes("Strategy"));
    });
    var insights;
    if (filteredInsights.length === 1) {
        insights = (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)(filteredInsights).concat((0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)((0,_utils_blogUtils__WEBPACK_IMPORTED_MODULE_11__/* .getRandom */ .s)(allInsights.filter(function(item) {
            return !filteredInsights.includes(item);
        }), 1)));
    } else if (filteredInsights.length >= 2) {
        insights = (0,_utils_blogUtils__WEBPACK_IMPORTED_MODULE_11__/* .getRandom */ .s)(filteredInsights, 2);
    } else {
        insights = (0,_utils_blogUtils__WEBPACK_IMPORTED_MODULE_11__/* .getRandom */ .s)(allInsights, 2);
    }
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_head__WEBPACK_IMPORTED_MODULE_1___default()), {
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("script", {
                    type: "application/ld+json",
                    dangerouslySetInnerHTML: {
                        __html: JSON.stringify(jsonLd)
                    }
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_services_Service2__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                heading: "Tech Stack Audit Services",
                paragraph: 'ITMTB provides tech stack audit services for companies that need clarity on their software architecture, cloud infrastructure, databases, integrations, security posture, performance risks, technical debt, and operations readiness before making major technology decisions.<ul style="margin-top:16px;padding-left:20px;list-style:disc;display:flex;flex-direction:column;gap:8px"><li>2-week fixed-scope audit sprint available</li><li>Application, cloud, database, security, and operations review</li><li>Written risk register and 30/60/90-day roadmap</li><li>Suitable before rebuilds, migrations, vendor transitions, scale-up, or AI adoption</li></ul>',
                primaryCta: null,
                heroSvg: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("svg", {
                    viewBox: "0 0 440 400",
                    fill: "none",
                    xmlns: "http://www.w3.org/2000/svg",
                    className: "w-full max-w-md opacity-70",
                    "aria-hidden": "true",
                    role: "presentation",
                    children: [
                        (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)(Array(6)).map(function(_, row) {
                            return (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)(Array(7)).map(function(_, col) {
                                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("circle", {
                                    cx: 40 + col * 60,
                                    cy: 28 + row * 60,
                                    r: "1.5",
                                    fill: "#e2e8f0"
                                }, "".concat(row, "-").concat(col));
                            });
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("rect", {
                            x: "68",
                            y: "22",
                            width: "304",
                            height: "40",
                            rx: "6",
                            stroke: "#94a3b8",
                            strokeWidth: "1.5"
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("rect", {
                            x: "68",
                            y: "88",
                            width: "304",
                            height: "40",
                            rx: "6",
                            stroke: "#94a3b8",
                            strokeWidth: "1.5"
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("rect", {
                            x: "68",
                            y: "154",
                            width: "304",
                            height: "40",
                            rx: "6",
                            stroke: "#94a3b8",
                            strokeWidth: "1.5"
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("rect", {
                            x: "68",
                            y: "220",
                            width: "304",
                            height: "40",
                            rx: "6",
                            stroke: "#94a3b8",
                            strokeWidth: "1.5"
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("rect", {
                            x: "68",
                            y: "286",
                            width: "304",
                            height: "40",
                            rx: "6",
                            stroke: "#94a3b8",
                            strokeWidth: "1.5"
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("rect", {
                            x: "61",
                            y: "147",
                            width: "318",
                            height: "54",
                            rx: "10",
                            stroke: "#94a3b8",
                            strokeWidth: "0.8",
                            strokeOpacity: "0.35",
                            strokeDasharray: "3 3"
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("rect", {
                            x: "61",
                            y: "279",
                            width: "318",
                            height: "54",
                            rx: "10",
                            stroke: "#94a3b8",
                            strokeWidth: "0.8",
                            strokeOpacity: "0.35",
                            strokeDasharray: "3 3"
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("line", {
                            x1: "220",
                            y1: "62",
                            x2: "220",
                            y2: "88",
                            stroke: "#cbd5e1",
                            strokeWidth: "1.5"
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("line", {
                            x1: "220",
                            y1: "128",
                            x2: "220",
                            y2: "154",
                            stroke: "#cbd5e1",
                            strokeWidth: "1.5"
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("line", {
                            x1: "220",
                            y1: "194",
                            x2: "220",
                            y2: "220",
                            stroke: "#cbd5e1",
                            strokeWidth: "1.5"
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("line", {
                            x1: "220",
                            y1: "260",
                            x2: "220",
                            y2: "286",
                            stroke: "#cbd5e1",
                            strokeWidth: "1.5"
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("circle", {
                            cx: "88",
                            cy: "42",
                            r: "2.5",
                            fill: "#cbd5e1"
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("circle", {
                            cx: "88",
                            cy: "108",
                            r: "2.5",
                            fill: "#cbd5e1"
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("circle", {
                            cx: "88",
                            cy: "174",
                            r: "2.5",
                            fill: "#cbd5e1"
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("circle", {
                            cx: "88",
                            cy: "240",
                            r: "2.5",
                            fill: "#cbd5e1"
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("circle", {
                            cx: "88",
                            cy: "306",
                            r: "2.5",
                            fill: "#cbd5e1"
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("circle", {
                            cx: "352",
                            cy: "42",
                            r: "3",
                            stroke: "#94a3b8",
                            strokeWidth: "1.2",
                            fill: "none"
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("circle", {
                            cx: "352",
                            cy: "108",
                            r: "3",
                            stroke: "#94a3b8",
                            strokeWidth: "1.2",
                            fill: "none"
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("circle", {
                            cx: "352",
                            cy: "174",
                            r: "3",
                            fill: "#b45309",
                            fillOpacity: "0.25",
                            stroke: "#b45309",
                            strokeWidth: "1.5"
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("circle", {
                            cx: "352",
                            cy: "240",
                            r: "3",
                            stroke: "#94a3b8",
                            strokeWidth: "1.2",
                            fill: "none"
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("circle", {
                            cx: "352",
                            cy: "306",
                            r: "3",
                            fill: "#b45309",
                            fillOpacity: "0.25",
                            stroke: "#b45309",
                            strokeWidth: "1.5"
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("line", {
                            x1: "50",
                            y1: "174",
                            x2: "390",
                            y2: "174",
                            stroke: "#b45309",
                            strokeWidth: "1.2",
                            strokeDasharray: "6 3",
                            strokeOpacity: "0.55"
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("circle", {
                            cx: "44",
                            cy: "174",
                            r: "3.5",
                            fill: "#b45309",
                            fillOpacity: "0.35"
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("circle", {
                            cx: "396",
                            cy: "174",
                            r: "3.5",
                            fill: "#b45309",
                            fillOpacity: "0.35"
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("circle", {
                            cx: "220",
                            cy: "174",
                            r: "14",
                            stroke: "#b45309",
                            strokeWidth: "1",
                            strokeOpacity: "0.3",
                            strokeDasharray: "4 2"
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("circle", {
                            cx: "220",
                            cy: "174",
                            r: "8",
                            stroke: "#b45309",
                            strokeWidth: "1.8",
                            fill: "none",
                            strokeOpacity: "0.6"
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("line", {
                            x1: "226",
                            y1: "180",
                            x2: "233",
                            y2: "187",
                            stroke: "#b45309",
                            strokeWidth: "1.8",
                            strokeOpacity: "0.5",
                            strokeLinecap: "round"
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("nav", {
                className: "bg-white border-b border-gray-100 px-6 md:px-[60px] py-2 overflow-x-auto",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: "flex gap-6 text-sm font-medium whitespace-nowrap",
                    children: [
                        {
                            label: "Who it's for",
                            href: "#who-its-for"
                        },
                        {
                            label: "What we audit",
                            href: "#what-we-audit"
                        },
                        {
                            label: "Deliverables",
                            href: "#deliverables"
                        },
                        {
                            label: "How it works",
                            href: "#how-it-works"
                        },
                        {
                            label: "Engagement models",
                            href: "#engagement-models"
                        },
                        {
                            label: "FAQ",
                            href: "#faq"
                        }, 
                    ].map(function(param) {
                        var label = param.label, href = param.href;
                        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                            href: href,
                            className: "text-gray-500 hover:text-indigo-600 transition-colors py-1",
                            children: label
                        }, href);
                    })
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_ai_agent_demo_CustomerSection__WEBPACK_IMPORTED_MODULE_8__/* .CustomerSection */ .a, {
                title: "Trusted by"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("section", {
                className: "px-8 md:px-[60px] py-12 bg-white border-t border-gray-100",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    className: "max-w-4xl",
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h2", {
                            className: "text-2xl md:text-3xl font-bold text-gray-900 mb-5",
                            children: "Technology decisions become expensive when the current stack is unclear"
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                            className: "text-gray-700 text-base md:text-lg leading-relaxed mb-4",
                            children: "Most companies do not need a rebuild on day one. They need clarity first."
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                            className: "text-gray-700 text-base md:text-lg leading-relaxed mb-4",
                            children: "A tech stack audit helps you understand what is working, what is fragile, what is undocumented, what is creating operational risk, and what needs to change before the next phase of growth."
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                            className: "text-gray-700 text-base md:text-lg leading-relaxed",
                            children: "ITMTB audits your application architecture, infrastructure, databases, APIs, third-party integrations, access controls, deployment process, observability, technical debt, and operational ownership. The output is a written assessment and a practical roadmap — not a generic consulting presentation."
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("p", {
                            className: "text-gray-700 text-base md:text-lg leading-relaxed mt-4",
                            children: [
                                "This is often where a migration begins. For a global market intelligence business, what looked like a simple ASP.NET migration turned into a full performance, security, and operations overhaul — see how we",
                                " ",
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_2___default()), {
                                    href: "/blog/website-optimization-security-market-intelligence",
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                        className: "text-indigo-600 hover:text-indigo-800 font-medium underline",
                                        children: "optimized and secured their website operations"
                                    })
                                }),
                                "."
                            ]
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("section", {
                id: "who-its-for",
                className: "scroll-mt-24 px-8 md:px-[60px] py-14 bg-gray-50 border-t border-gray-100",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    className: "max-w-4xl",
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h2", {
                            className: "text-2xl md:text-3xl font-bold text-gray-900 mb-10",
                            children: "Who should consider a tech stack audit?"
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: "space-y-10",
                            children: [
                                {
                                    heading: "Companies planning to rebuild or modernise a legacy application",
                                    body: "Before committing to a rebuild, you need to know what you actually have — what is worth keeping, what is creating risk, and what a realistic migration path looks like. An audit prevents decisions being made against an inaccurate picture of the existing system."
                                },
                                {
                                    heading: "Founders and CXOs unsure whether the current stack can support growth",
                                    body: "If you are planning a scale-up, new product line, AI adoption, or significant increase in usage, an audit tells you whether the current architecture can carry that load — and at what cost."
                                },
                                {
                                    heading: "Companies transitioning away from an existing software vendor",
                                    body: "A vendor transition requires understanding the condition of the system being handed over. The audit identifies dependencies, undocumented logic, missing documentation, and operational risks before you commit to the transition."
                                },
                                {
                                    heading: "Teams facing repeated outages, slow releases, or unclear ownership",
                                    body: "Operational problems usually have technical root causes. An audit surfaces the architectural and process decisions behind reliability issues, slow deployments, and escalating incident rates."
                                },
                                {
                                    heading: "Investors, founders, or leadership teams needing technical due diligence",
                                    body: "Before a funding round, acquisition, or major technology investment, independent technical due diligence gives leadership and investors an accurate view of what they are committing to."
                                },
                                {
                                    heading: "Organisations preparing for cloud migration, security hardening, or AI automation",
                                    body: "Each of these initiatives requires understanding the current state before designing the target state. An audit prevents expensive rework caused by assumptions that turn out to be wrong."
                                }, 
                            ].map(function(item) {
                                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h3", {
                                            className: "text-lg font-bold text-gray-900 mb-2",
                                            children: item.heading
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                            className: "text-gray-600 text-base leading-relaxed",
                                            children: item.body
                                        })
                                    ]
                                }, item.heading);
                            })
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("section", {
                className: "px-8 md:px-[60px] py-14 bg-white border-t border-gray-100",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    className: "max-w-4xl",
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h2", {
                            className: "text-2xl md:text-3xl font-bold text-gray-900 mb-6",
                            children: "Weak technology stacks rarely fail in one obvious place"
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                            className: "text-gray-700 text-base md:text-lg leading-relaxed mb-4",
                            children: "Technology risk usually builds slowly. A system may look functional from the outside while hiding serious problems inside the architecture, deployment process, database design, cloud setup, access controls, vendor dependencies, or support model."
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                            className: "text-gray-700 text-base md:text-lg leading-relaxed mb-8",
                            children: "A tech stack audit gives leadership a structured view of these risks before they become expensive failures."
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                            className: "text-xs font-semibold uppercase tracking-widest text-gray-400 mb-5",
                            children: "Common signs that an audit is warranted"
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: "grid grid-cols-1 sm:grid-cols-2 gap-3",
                            children: [
                                "No clear architecture documentation",
                                "Slow releases and frequent production issues",
                                "Rising cloud costs without clear usage visibility",
                                "Database bottlenecks or fragile data flows",
                                "Too much dependency on one vendor or developer",
                                "Poor monitoring, logging, and incident visibility",
                                "Security and access-control gaps",
                                "Legacy frameworks or unsupported components",
                                "Integrations that break during small changes",
                                "No clear decision on whether to fix, rebuild, migrate, or replace", 
                            ].map(function(sign) {
                                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                    className: "flex items-center gap-3 bg-gray-50 border border-gray-100 rounded-lg px-4 py-3",
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                            className: "w-1.5 h-1.5 rounded-full bg-amber-500 flex-shrink-0"
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                            className: "text-sm text-gray-700",
                                            children: sign
                                        })
                                    ]
                                }, sign);
                            })
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                id: "what-we-audit",
                className: "scroll-mt-24",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Capabilities2, {
                    dataList: auditAreas,
                    bg: "bg-[#402A6A]",
                    insights: (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)(caseStudies).concat((0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)(insights)),
                    hideFooter: true,
                    hideCardSubtitle: true
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("section", {
                id: "deliverables",
                className: "scroll-mt-24 px-8 md:px-[60px] py-14 bg-white border-t border-gray-100",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    className: "max-w-4xl",
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h2", {
                            className: "text-2xl md:text-3xl font-bold text-gray-900 mb-3",
                            children: "What you receive"
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                            className: "text-gray-600 text-base md:text-lg mb-8",
                            children: "At the end of the audit, ITMTB provides a written report designed for both technical and business stakeholders."
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                            className: "grid grid-cols-1 md:grid-cols-2 gap-6",
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                    className: "bg-gray-50 border border-gray-200 rounded-xl p-6",
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                            className: "text-xs font-semibold uppercase tracking-widest text-gray-400 mb-4",
                                            children: "Assessment output"
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("ul", {
                                            className: "space-y-2.5",
                                            children: [
                                                "Current-state technology stack summary",
                                                "Architecture and infrastructure observations",
                                                "Database, cloud, security, and integration risk areas",
                                                "Technical debt assessment",
                                                "Performance and scalability findings",
                                                "Vendor and operational dependency risks", 
                                            ].map(function(item) {
                                                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("li", {
                                                    className: "flex items-start gap-2 text-sm text-gray-700",
                                                    children: [
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                                            className: "mt-1.5 w-1.5 h-1.5 rounded-full bg-indigo-400 flex-shrink-0"
                                                        }),
                                                        item
                                                    ]
                                                }, item);
                                            })
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                    className: "bg-gray-50 border border-gray-200 rounded-xl p-6",
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                            className: "text-xs font-semibold uppercase tracking-widest text-gray-400 mb-4",
                                            children: "Decision support"
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("ul", {
                                            className: "space-y-2.5",
                                            children: [
                                                "Build-vs-extend-vs-replace recommendation",
                                                "Prioritised risk register",
                                                "30/60/90-day improvement roadmap",
                                                "Effort and sequencing for each improvement area",
                                                "Optional implementation and managed-operations plan", 
                                            ].map(function(item) {
                                                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("li", {
                                                    className: "flex items-start gap-2 text-sm text-gray-700",
                                                    children: [
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                                            className: "mt-1.5 w-1.5 h-1.5 rounded-full bg-indigo-400 flex-shrink-0"
                                                        }),
                                                        item
                                                    ]
                                                }, item);
                                            })
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                            className: "text-gray-500 text-sm mt-6 leading-relaxed",
                            children: "The goal is not to produce a long theoretical report. The goal is to help leadership decide what to do next."
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("section", {
                id: "how-it-works",
                className: "scroll-mt-24 px-8 md:px-[60px] py-14 bg-gray-50 border-t border-gray-100",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    className: "max-w-5xl",
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h2", {
                            className: "text-2xl md:text-3xl font-bold text-gray-900 mb-3",
                            children: "How the engagement works"
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                            className: "text-gray-600 text-base md:text-lg mb-10",
                            children: "A defined five-phase process — no build commitment before the audit is complete."
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: "grid grid-cols-1 md:grid-cols-2 gap-6",
                            children: engagementPhases.map(function(phase) {
                                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                    className: "bg-white border border-gray-200 rounded-xl p-6",
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                            className: "flex items-start gap-4 mb-5",
                                            children: [
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                                    className: "text-3xl font-bold text-indigo-200 leading-none select-none",
                                                    children: phase.phase
                                                }),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h3", {
                                                        className: "text-base font-bold text-gray-900",
                                                        children: phase.title
                                                    })
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("ul", {
                                            className: "space-y-2.5",
                                            children: phase.items.map(function(item) {
                                                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("li", {
                                                    className: "flex items-start gap-2 text-sm text-gray-700",
                                                    children: [
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                                            className: "mt-1.5 w-1 h-1 rounded-full bg-gray-400 flex-shrink-0"
                                                        }),
                                                        item
                                                    ]
                                                }, item);
                                            })
                                        })
                                    ]
                                }, phase.phase);
                            })
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_2___default()), {
                            href: "/itmtb-how-we-work",
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                className: "mt-8 inline-flex items-center text-sm font-semibold text-indigo-600 hover:text-indigo-800 transition-colors",
                                children: "See the full engagement methodology →"
                            })
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("section", {
                id: "engagement-models",
                className: "scroll-mt-24 px-8 md:px-[60px] py-14 bg-white border-t border-gray-100",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    className: "max-w-5xl",
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h2", {
                            className: "text-2xl md:text-3xl font-bold text-gray-900 mb-3",
                            children: "Flexible audit models based on decision urgency"
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                            className: "text-gray-600 text-base md:text-lg mb-10",
                            children: "Choose the depth of assessment that fits the decision you need to make."
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: "grid grid-cols-1 md:grid-cols-3 gap-6",
                            children: engagementModels.map(function(model) {
                                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                    className: "bg-gray-50 border border-gray-200 rounded-xl p-6 flex flex-col",
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                            className: "mb-4",
                                            children: [
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h3", {
                                                    className: "text-base font-bold text-gray-900 mb-1",
                                                    children: model.label
                                                }),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                                    className: "text-xs font-semibold text-indigo-500 uppercase tracking-wide",
                                                    children: model.duration
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                            className: "text-sm text-gray-600 leading-relaxed mb-5",
                                            children: model.description
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                            className: "mt-auto",
                                            children: [
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                                    className: "text-xs font-semibold uppercase tracking-widest text-gray-400 mb-3",
                                                    children: "Best for"
                                                }),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("ul", {
                                                    className: "space-y-2",
                                                    children: model.bestFor.map(function(item) {
                                                        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("li", {
                                                            className: "flex items-start gap-2 text-sm text-gray-700",
                                                            children: [
                                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                                                    className: "mt-1.5 w-1 h-1 rounded-full bg-gray-400 flex-shrink-0"
                                                                }),
                                                                item
                                                            ]
                                                        }, item);
                                                    })
                                                })
                                            ]
                                        })
                                    ]
                                }, model.label);
                            })
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("section", {
                className: "py-12 px-6 md:px-[60px] bg-gray-50 border-t border-gray-100",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    className: "max-w-6xl",
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h2", {
                            className: "text-2xl md:text-3xl font-bold text-gray-900 mb-8 text-left",
                            children: "Tech stack audit in practice"
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: "grid grid-cols-1 md:grid-cols-3 gap-6 mb-8",
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_2___default()), {
                                href: "/blog/".concat(featuredStory.slug),
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("a", {
                                    className: "group bg-white border border-gray-200 rounded-xl overflow-hidden hover:border-blue-400 hover:shadow-md transition-all flex flex-col md:col-span-1",
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                            className: "relative w-full h-44 bg-gray-100",
                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_future_image__WEBPACK_IMPORTED_MODULE_9___default()), {
                                                src: featuredStory.img,
                                                alt: featuredStory.title,
                                                fill: true,
                                                className: "object-cover",
                                                sizes: "(max-width: 768px) 100vw, 400px",
                                                placeholder: "blur",
                                                blurDataURL: "/blogImages/hero/placeholder.webp"
                                            })
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                            className: "p-5 flex flex-col flex-1",
                                            children: [
                                                featuredStory.industry_descriptor && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                                    className: "text-blue-500 text-xs uppercase tracking-wide font-medium mb-2",
                                                    children: featuredStory.industry_descriptor
                                                }),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h3", {
                                                    className: "text-base font-semibold text-gray-900 group-hover:text-blue-600 transition-colors leading-snug mb-3 flex-1",
                                                    children: featuredStory.title
                                                }),
                                                featuredStory.outcome_metric && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                                    className: "text-sm text-gray-500 mt-auto pt-3 border-t border-gray-100",
                                                    children: featuredStory.outcome_metric
                                                })
                                            ]
                                        })
                                    ]
                                })
                            })
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_2___default()), {
                            href: "/success-stories",
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                className: "inline-block border border-gray-300 hover:border-blue-500 text-gray-700 hover:text-blue-600 font-semibold px-7 py-3 rounded-lg transition-colors text-sm",
                                children: "See all success stories →"
                            })
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("section", {
                className: "px-8 md:px-[60px] py-14 bg-white border-t border-gray-100",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    className: "max-w-4xl",
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h2", {
                            className: "text-2xl md:text-3xl font-bold text-gray-900 mb-6",
                            children: "We audit the stack as a production system, not as a tool list"
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                            className: "text-gray-700 text-base md:text-lg leading-relaxed mb-4",
                            children: "A useful technology audit is not just an inventory of programming languages, frameworks, databases, and cloud services."
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                            className: "text-gray-700 text-base md:text-lg leading-relaxed mb-8 font-medium",
                            children: "The real question is: can this stack support the business safely, reliably, and efficiently in its next phase?"
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                            className: "text-gray-700 text-base md:text-lg leading-relaxed mb-8",
                            children: "That requires looking at the full system — how the application is built, how the cloud is configured, how data moves, how releases happen, how failures are detected, how access is controlled, how incidents are handled, how much risk sits with one vendor or individual, and how easily the system can evolve."
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                            className: "text-gray-700 text-base md:text-lg leading-relaxed",
                            children: "ITMTB combines software engineering, cloud operations, cybersecurity, quality engineering, enterprise applications, AI deployment, and managed services experience to assess the stack as a working business system."
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("section", {
                className: "px-8 md:px-[60px] py-14 bg-gray-50 border-t border-gray-100",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    className: "max-w-5xl",
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                            className: "text-xs font-semibold uppercase tracking-widest text-gray-400 mb-7",
                            children: "Related capabilities"
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: "grid grid-cols-1 md:grid-cols-3 gap-5",
                            children: [
                                {
                                    href: "/services/data-center-project-readiness-governance",
                                    label: "Data Centre Readiness",
                                    desc: "Infrastructure readiness assessment and delivery governance for organisations planning a captive, DR, or hybrid data centre setup."
                                },
                                {
                                    href: "/services/technology-consulting",
                                    label: "Technology Consulting",
                                    desc: "Technical due diligence, architecture decisions, rebuild-vs-extend evaluation, and technology roadmap planning."
                                },
                                {
                                    href: "/services/managed-services",
                                    label: "Managed Services",
                                    desc: "Ongoing operations, monitoring, maintenance, reporting, and escalation ownership for live systems."
                                },
                                {
                                    href: "/services/cloud",
                                    label: "Cloud Infrastructure",
                                    desc: "Cloud architecture, migration, optimisation, monitoring, and infrastructure operations."
                                },
                                {
                                    href: "/services/cybersecurity",
                                    label: "Cybersecurity",
                                    desc: "Security reviews, access-control improvements, compliance readiness, and cyber-risk assessment."
                                },
                                {
                                    href: "/services/quality-engineering",
                                    label: "Quality Engineering",
                                    desc: "Test strategy, automation, performance assurance, release quality, and production defect reduction."
                                },
                                {
                                    href: "/services/enterprise-applications",
                                    label: "Enterprise Applications",
                                    desc: "Modernisation, workflow automation, integrations, and business-critical application engineering."
                                }, 
                            ].map(function(link) {
                                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_2___default()), {
                                    href: link.href,
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("a", {
                                        className: "block bg-white border border-gray-200 rounded-xl p-6 hover:border-indigo-400 hover:shadow-sm transition-all group",
                                        children: [
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h3", {
                                                className: "text-base font-semibold text-gray-900 group-hover:text-indigo-600 transition-colors mb-2",
                                                children: link.label
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                                className: "text-sm text-gray-500 leading-relaxed",
                                                children: link.desc
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                                className: "mt-4 inline-block text-sm font-semibold text-indigo-500 group-hover:text-indigo-700 transition-colors",
                                                children: "Learn more →"
                                            })
                                        ]
                                    })
                                }, link.href);
                            })
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                id: "faq",
                className: "scroll-mt-24",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_services_ServiceFAQ__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                    items: faqItems
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_services_ServiceEngagementLinks__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {}),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("section", {
                className: "px-8 md:px-[60px] py-16 bg-[#0d0822]",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    className: "max-w-3xl mx-auto text-center",
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                            className: "text-xs font-semibold uppercase tracking-widest text-indigo-400 mb-5",
                            children: "Start the conversation"
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h2", {
                            className: "text-2xl md:text-3xl font-bold text-white mb-5",
                            children: "Get an independent view of your current technology stack"
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                            className: "text-slate-300 text-base md:text-lg leading-relaxed mb-8",
                            children: "Before you rebuild, migrate, scale, automate, or change vendors, understand the real condition of your current system. ITMTB's tech stack audit identifies risks, technical debt, operational gaps, security concerns, and modernisation priorities — then converts them into a practical roadmap."
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_2___default()), {
                            href: "/contact-us?utm_source=service-tech-stack-audit&utm_content=bottom-cta",
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                className: "inline-block bg-[#f1aa4e] text-black font-semibold text-base px-8 py-3.5 rounded-md hover:bg-[#e09a3e] transition-colors",
                                children: "Request a Tech Stack Audit →"
                            })
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Footer, {})
        ]
    });
};


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [1608,8657,2684,1831,9774,2888,179], function() { return __webpack_exec__(560); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);